import { handleActions } from 'redux-actions';

import * as types from './types';

const initialState = {
  data: [],
  error: null,
  initialLoad: false,
  loading: false,
  loadingId: null,
  saving: false,
};

const createTimesheetRowRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const createTimesheetRowRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const createTimesheetRowRequestSuccess = (state, payload) => {
  const data = [...state.data];
  data.unshift(payload.data);
  return {
    ...state,
    data,
    error: null,
    saving: false,
  };
};

const deleteTimesheetRowRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const deleteTimesheetRowRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const deleteTimesheetRowRequestSuccess = (state, payload) => {
  const data = [...state.data].filter((d) => {
    return d.id !== payload.data.rowId;
  });
  return {
    ...state,
    data,
    error: null,
    saving: false,
  };
};

const getTimesheetRowRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
  saving: false,
});
const getTimesheetRowRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  saving: false,
});
const getTimesheetRowRequestSuccess = (state, payload) => {
  const data = [...state.data];
  data.map((row) => {
    if (row.id === payload.data.id) {
      return { ...row, ...payload.data };
    }
    return row;
  });
  return {
    ...state,
    data,
    error: null,
    loading: false,
    saving: false,
  };
};

const getTimesheetRowsRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
  saving: false,
});
const getTimesheetRowsRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  loading: false,
  saving: false,
});
const getTimesheetRowsRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: payload.data,
    error: null,
    initialLoad: true,
    loading: false,
    saving: false,
  };
};

const resetTimesheetRowsState = (state, payload) => initialState;

export default handleActions(
  {
    [types.CREATE_TIMESHEET_ROW_REQUEST]: createTimesheetRowRequest,
    [types.CREATE_TIMESHEET_ROW_REQUEST_FAILURE]: createTimesheetRowRequestFailure,
    [types.CREATE_TIMESHEET_ROW_REQUEST_SUCCESS]: createTimesheetRowRequestSuccess,
    [types.DELETE_TIMESHEET_ROW_REQUEST]: deleteTimesheetRowRequest,
    [types.DELETE_TIMESHEET_ROW_REQUEST_FAILURE]: deleteTimesheetRowRequestFailure,
    [types.DELETE_TIMESHEET_ROW_REQUEST_SUCCESS]: deleteTimesheetRowRequestSuccess,
    [types.GET_TIMESHEET_ROW_REQUEST]: getTimesheetRowRequest,
    [types.GET_TIMESHEET_ROW_REQUEST_FAILURE]: getTimesheetRowRequestFailure,
    [types.GET_TIMESHEET_ROW_REQUEST_SUCCESS]: getTimesheetRowRequestSuccess,
    [types.GET_TIMESHEET_ROWS_REQUEST]: getTimesheetRowsRequest,
    [types.GET_TIMESHEET_ROWS_REQUEST_FAILURE]: getTimesheetRowsRequestFailure,
    [types.GET_TIMESHEET_ROWS_REQUEST_SUCCESS]: getTimesheetRowsRequestSuccess,
    [types.RESET_TIMESHEET_ROWS_STATE]: resetTimesheetRowsState,
  },
  initialState,
);
